import styled from '@emotion/styled'

const newMessageFilter = () => (
' brightness(0) saturate(100%) invert(91%) sepia(16%) saturate(755%) hue-rotate(107deg) brightness(100%) contrast(89%) '
)

const dropShadowFilter = () => (
  'drop-shadow(2px 1px 2px rgba(0,0,0,0.5))'
)

const SentReplyImage = styled.img`
  drop-shadow(2px 1px 2px rgba(0,0,0,1))
`

const SentOrReply = ({ mapUserData, size, style, ...rest }) => {
  if (!mapUserData || !mapUserData?.lastMessage) return;
  const sentOrReply = mapUserData.lastMessage?.nearbyUuid === mapUserData.nearbyUuid ? 'reply' : 'sent'
  const src = `https://mandrake-app.b-cdn.net/dev/application/icons/${sentOrReply}.svg`
  const isNewReply = sentOrReply === 'reply' && mapUserData?.lastMessage?.isNew

  return (
    <SentReplyImage
      src={src}
      style={{
        height: size,
        width: size,
        // filter: isNewReply ? dropShadowFilter() + newMessageFilter() : dropShadowFilter(),
        filter: isNewReply && newMessageFilter(),
        ...style,
      }}
      {...rest}
    />
  )
}

export { SentOrReply }
